import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import { Cookies } from 'react-cookie';
import axios from 'axios';

const initialState = {
    type: {},
    total: 0,
    pages: 0,
    types: [],
    select: [],
    current: 0,
    error: null,
    uloader: false,
    loading: false,
    assigntypes: [],
    vechilePrice: {},
    vechileload: false,
}

export const VechileTypeReq = createAsyncThunk('VechileTypeReq', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/all/vechiletype`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const assignVechileTypeReq = createAsyncThunk('assignVechileTypeReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/assign-vechiletype`,
            data, { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const removeVechileTypeReq = createAsyncThunk('removeVechileTypeReq', async ({ data, id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/remove-vechiletype/${id}`, data, { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const createTypeReq = createAsyncThunk('createTypeReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.post(`${BASEURL}/admin/vechiletype/create`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    navigate('/admin/vechile-types')
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const listTypeReq = createAsyncThunk('listTypeReq', async ({ page, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/vechiletype/list?page=${page}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const SelectTypeReq = createAsyncThunk('SelectTypeReq', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/vechiletype/select`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleTypeReq = createAsyncThunk('singleTypeReq', async ({ id, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/vechiletype/info/${id}?page=${page}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const updateTypeReq = createAsyncThunk('updateTypeReq', async ({ id, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.put(`${BASEURL}/admin/vechiletype/update/${id}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            })
            .then((res) => {
                if (res.data.success) {
                    dispatch(toastSuccess(res.data.message))
                    navigate('/admin/vechile-types')
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteTypeReq = createAsyncThunk('deleteTypeReq', async ({ id, page, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/vechiletype/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res.data.message))
                    dispatch(listTypeReq({ page, text }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const vechilePriceReq = createAsyncThunk('vechilePriceReq', async ({ countrycode, id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/vechile-price/${countrycode}/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const vechilePriceDelete = createAsyncThunk('vechilePriceDelete', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/vechile-price/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(singleTypeReq({ id, page: 'view' }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const VechileTypeSlice = createSlice({
    name: 'vechileTypeSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(createTypeReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(createTypeReq.fulfilled, (state, action) => {
            state.uloader = false
            return state
        })
        builder.addCase(createTypeReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
        })
        builder.addCase(listTypeReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.types = []
            return state
        })
        builder.addCase(listTypeReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            state.types = action.payload.data?.types
            return state
        })
        builder.addCase(listTypeReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.types = []
            state.error = 'Error occured'
        })
        builder.addCase(singleTypeReq.pending, (state, action) => {
            state.loading = true
            state.type = {}
            return state
        })
        builder.addCase(singleTypeReq.fulfilled, (state, action) => {
            state.loading = false
            state.type = action.payload.data
            return state
        })
        builder.addCase(singleTypeReq.rejected, (state, action) => {
            state.loading = false
            state.type = {}
            state.error = 'Error occured'
        })
        builder.addCase(updateTypeReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(updateTypeReq.fulfilled, (state, action) => {
            state.uloader = false
            state.type = {}
            return state
        })
        builder.addCase(updateTypeReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
        })
        builder.addCase(SelectTypeReq.pending, (state, action) => {
            state.uloader = true
            state.select = []
            return state
        })
        builder.addCase(SelectTypeReq.fulfilled, (state, action) => {
            state.uloader = false
            state.select = action.payload.data
            return state
        })
        builder.addCase(SelectTypeReq.rejected, (state, action) => {
            state.uloader = false
            state.select = []
            state.error = 'Error occured'
        })

        builder.addCase(vechilePriceReq.pending, (state, action) => {
            state.vechileload = true
            state.vechilePrice = {}
            return state
        })
        builder.addCase(vechilePriceReq.fulfilled, (state, action) => {
            state.vechileload = false
            state.vechilePrice = action.payload.data
            return state
        })
        builder.addCase(vechilePriceReq.rejected, (state, action) => {
            state.vechileload = false
            state.select = {}
            state.error = 'Error occured'
        })

        builder.addCase(VechileTypeReq.pending, (state, action) => {
            state.assigntypes = []
            return state
        })
        builder.addCase(VechileTypeReq.fulfilled, (state, action) => {
            state.assigntypes = action.payload.data
            return state
        })
        builder.addCase(VechileTypeReq.rejected, (state, action) => {
            state.assigntypes = []
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default VechileTypeSlice.reducer